module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1286.b78f36b2.png";